// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { useDifusiones } from "../context/DifusionesContext";
import { useBody } from '../../Body/state/BodyContext';
import { useAreas } from '../../Areas/State/AreasContext';
import { useAuth } from '../../Auth/State/AuthContext';
import Tabla from "../../Componentes/Tabla";
import { BorrarListaModal } from "./BorrarListaModal";
import { ModificarListaModal } from "./ModificarListaModal";
import { VistaListasModal } from "./VistaListasModal";
import { DesvincularListaModal } from './DesvincularListaModal';
import { Box, useMediaQuery, IconButton, Tabs, Tab } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';

export default function ListaDeListaDeEmails() {
    const { hasRole } = useAuth();
    const { setMessage } = useBody();
    const { getAreaNamesByIds } = useAreas();
    const { obtenerListas, listas, areasUser } = useDifusiones();

    const propias = listas.filter(l => !l.esCompartido);
    const compartidas = listas.filter(l => l.esCompartido);
    const [areaNamesMap, setAreaNamesMap] = useState({});
    const [tab, setTab] = useState(0);
    const [loadingListas, setLoadingListas] = useState(true);
    const [loadingCompartidas, setLoadingCompartidas] = useState(false);
    const compartidaAreasFetched = useRef(false);

    const [listaSeleccionada, setListaSeleccionada] = useState({});
    const [openDialogEliminar, setOpenDialogEliminar] = useState(false);
    const [openDialogModificar, setOpenDialogModificar] = useState(false);
    const [openDialogVista, setOpenDialogVista] = useState(false);
    const [openDialogDesvincular, setOpenDialogDesvincular] = useState(false);

    const matches = useMediaQuery('(min-width:1000px)');

    const cargarListas = async (conLoading = true) => {
        if (conLoading) setLoadingListas(true);
        try {
            await obtenerListas();
            const knownAreas = {};
            areasUser.forEach(a => { knownAreas[a.id] = a.name; });
            setAreaNamesMap(knownAreas);
        } catch (error) {
            console.error("Error al obtener listas: ", error);
            setMessage("Hubo un error al traer las listas");
        } finally {
            if (conLoading) setLoadingListas(false);
        }
    };

    useEffect(() => {
        cargarListas();
    }, []);

    const handleTabChange = async (_, newTab) => {
        setTab(newTab);
        if (newTab === 1 && !compartidaAreasFetched.current) {
            compartidaAreasFetched.current = true;
            const unknownIds = [...new Set(
                compartidas
                    .map(l => l.propietario)
                    .filter(id => id && !areaNamesMap[id])
            )];
            if (unknownIds.length > 0) {
                setLoadingCompartidas(true);
                try {
                    const extraAreas = await getAreaNamesByIds(unknownIds);
                    setAreaNamesMap(prev => {
                        const next = { ...prev };
                        extraAreas.forEach(a => { next[a.id] = a.name; });
                        return next;
                    });
                } catch (error) {
                    console.error("Error al obtener áreas compartidas:", error);
                } finally {
                    setLoadingCompartidas(false);
                }
            }
        }
    };

    const columns = [
        { header: 'Nombre de Lista', accessorKey: 'nombre' },
        {
            header: 'Área',
            id: 'propietario',
            accessorFn: (row) => areaNamesMap[row.propietario] ?? row.propietario,
        },
        { header: 'Cantidad de Correos', accessorKey: 'cantidadDeCorreos' },
    ];

    const responsive = [
        { header: 'Nombre de Lista', accessorKey: 'nombre' },
    ];

    const renderRowActions = ({ row }) => (
        <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
            <IconButton color="secondary" onClick={(e) => { e.stopPropagation(); setListaSeleccionada(row.original); setOpenDialogVista(true); }}>
                <VisibilityIcon />
            </IconButton>
            {!row.original.esCompartido && (
                <IconButton
                    color="secondary"
                    disabled={!hasRole(["ROLE_MODIFICAR_DESTINATARIO"])}
                    onClick={(e) => { e.stopPropagation(); setListaSeleccionada(row.original); setOpenDialogModificar(true); }}
                >
                    <Edit />
                </IconButton>
            )}
            <IconButton
                color="secondary"
                disabled={!hasRole(["ROLE_BORRAR_DESTINATARIO"])}
                onClick={(e) => {
                    e.stopPropagation();
                    setListaSeleccionada(row.original);
                    row.original.esCompartido ? setOpenDialogDesvincular(true) : setOpenDialogEliminar(true);
                }}
            >
                {row.original.esCompartido
                    ? <ElectricalServicesIcon style={{ color: "red" }} />
                    : <DeleteIcon style={{ color: "red" }} />
                }
            </IconButton>
        </Box>
    );

    const muiTableBodyRowProps = ({ row }) => ({
        onClick: () => { setListaSeleccionada(row.original); setOpenDialogVista(true); },
        sx: { cursor: 'pointer' },
    });

    return (
        <Box sx={{ padding: matches ? '16px' : '0px' }}>
            <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }}>
                <Tab label={`Propias (${propias.length})`} sx={{ textTransform: 'none' }} />
                <Tab label={`Compartidas (${compartidas.length})`} sx={{ textTransform: 'none' }} />
            </Tabs>

            {tab === 0 && (
                <Tabla
                    getRowId={(row) => row.uid}
                    columns={matches ? columns : responsive}
                    data={propias}
                    state={{ isLoading: loadingListas }}
                    muiTableContainerProps={{ sx: { height: '50vh' } }}
                    enableFullScreenToggle={false}
                    enableRowActions
                    positionActionsColumn='last'
                    renderRowActions={renderRowActions}
                    muiTableBodyRowProps={muiTableBodyRowProps}
                />
            )}

            {tab === 1 && (
                <Tabla
                    getRowId={(row) => row.uid}
                    columns={matches ? columns : responsive}
                    data={compartidas}
                    state={{ isLoading: loadingCompartidas }}
                    muiTableContainerProps={{ sx: { height: '50vh' } }}
                    enableFullScreenToggle={false}
                    enableRowActions
                    positionActionsColumn='last'
                    renderRowActions={renderRowActions}
                    muiTableBodyRowProps={muiTableBodyRowProps}
                />
            )}

            <VistaListasModal
                listaSeleccionada={listaSeleccionada}
                open={openDialogVista}
                onClose={() => setOpenDialogVista(false)}
                areaNamesMap={areaNamesMap}
            />
            <ModificarListaModal
                listaSeleccionada={listaSeleccionada}
                open={openDialogModificar}
                onClose={() => setOpenDialogModificar(false)}
                onSuccess={() => cargarListas(false)}
            />
            <BorrarListaModal
                listaSeleccionada={listaSeleccionada}
                open={openDialogEliminar}
                onClose={() => setOpenDialogEliminar(false)}
                onSuccess={() => cargarListas(false)}
            />
            <DesvincularListaModal
                listaSeleccionada={listaSeleccionada}
                open={openDialogDesvincular}
                onClose={() => setOpenDialogDesvincular(false)}
                onSuccess={() => cargarListas(false)}
            />
        </Box>
    );
}
